module.exports = __webpack_public_path__ + "img/4.d6ff3f28.png";